import {
  styled,
  Select as BaseSelect,
  TextField as BaseTextField,
  InputLabel as BaseInputLabel,
  FormHelperText,
  Theme,
} from '@material-ui/core'

const SELECT_HEIGHT = 32
const INPUT_HEIGHT = SELECT_HEIGHT
const HELPER_TEXT_TOP = 52
const HELPER_TEXT_LEFT = 4
const SELECT_ICON_WIDTH = 20
const SELECT_ICON_RIGHT = 5

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
})

export const InputContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  height: 'max-content',
}))

export const Select = styled(BaseSelect)(
  ({ theme, error }: { theme: Theme; error: boolean }) => ({
    height: SELECT_HEIGHT,
    width: 'max-content',
    borderRadius: '0px 10px 10px 0px',
    position: 'relative',
    '& fieldset': {
      top: 0,
    },
    '& svg': {
      position: 'absolute',
      right: SELECT_ICON_RIGHT,
      top: 'auto',
      botom: 'auto',
      color: error ? theme.palette.error.main : theme.palette.primary.main,
      transition: 'all .3s',
      width: SELECT_ICON_WIDTH,
    },
    '& .MuiSelect-root': {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(),
    },
    '& .MuiPopover-root': {
      '& .MuiPaper-root': {
        '& .Mui-selected': {
          backgroundColor: theme.palette.common.white,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          },
        },
      },
    },
  })
)

export const TextField = styled(BaseTextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    height: INPUT_HEIGHT,
    borderRadius: '10px 0px 0px 10px',
    '& fieldset': {
      borderRight: 'none',
      top: 0,
    },
  },
}))

export const HelperText = styled(FormHelperText)({
  position: 'absolute',
  top: HELPER_TEXT_TOP,
  left: HELPER_TEXT_LEFT,
  lineHeight: 1.1,
})

export const InputLabel = styled(BaseInputLabel)(({ theme }) => ({
  marginBottom: theme.spacing(),
  whiteSpace: 'nowrap',
}))
